import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('./vacation-homework/index.vue')
const Records = () => import('./vacation-homework/SendRecords.vue')

export const indexRoute: RouteConfig = {
  path: '/winter-vacation-homework-2025',
  name: 'winter_vacation_homework_2025',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026年中小学AI寒假体育作业指南',
    ignoreLogin: true,
  },
}
export const recordsRoute: RouteConfig = {
  path: '/winter-vacation-homework-2025-records',
  name: 'winter_vacation_homework_2025_records',
  component: Records,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '邀请记录',
    ignoreLogin: true,
  },
}

export default [indexRoute, recordsRoute]

export function navigateToWinterVacation2025Homework(router: VueRouter, qd?: string) {
  router.push({ name: indexRoute.name, query: { qd } })
}
